import * as Sentry from '@sentry/react'
import { initLogger } from '@paintscout/logger'
// import { BrowserTracing } from '@sentry/tracing'

// const envSentry = ['dev', 'test', 'staging'].includes(process.env.DEPLOYMENT_STAGE)
//   ? {
//       integrations: [
//         new Sentry.Replay({
//           maskAllText: false,
//           maskAllInputs: false,
//           blockAllMedia: false
//         }),
//         new BrowserTracing()
//       ],
//       replaysSessionSampleRate: 1.0,
//       replaysOnErrorSampleRate: 1.0,
//       tracesSampleRate: 1.0
//     }
//   : {}
const envSentry = {}

Sentry.init({
  dsn: process.env.SENTRY_APP_DSN,
  release: `${process.env.VERSION}`,
  environment: process.env.DEPLOYMENT_STAGE,

  ...envSentry,

  ignoreErrors: [
    /^typeError: failed to fetch$/i,
    /^typeError: cancelled$/i,
    /Cannot resolve a Slate point from DOM point/i,
    /newestWorker is null/i,
    /Invariant Violation: 8/i,
    /ceCurrentVideo.currentTime/i,
    /undefined is not an object .* evaluating .*length/i,
    /network/i,
    // this error gets thrown when device is offline, and is expected.
    /Failed to update a ServiceWorker for scope/i,
    /reading 'collection'/i,
    /evaluating 'this.active.collection'/i,
    /evaluating 'a.active.collection'/i,
    /this.active is null/i,
    /evaluating 'this.g.src'/i,
    /Script https:\/\/app.paintscout.com\/sw.js load failed/i
  ],
  beforeSend(event, _) {
    // Catch Non-Error exceptions and grab __serialized__ info and send as error instead, null if none present
    const isNonErrorException = (event.exception?.values?.[0]?.value ?? '').startsWith('Non-Error exception captured')
    if (isNonErrorException) {
      if (!event.extra.__serialized__) {
        return null
      }
      let realErrMsg = (event.extra.__serialized__ as any)?.error
        ? (event.extra.__serialized__ as any)?.error.message
        : null
      realErrMsg = realErrMsg || (event.extra.__serialized__ as any)?.message
      event.exception.values[0].value = realErrMsg
      event.message = realErrMsg
    }
    return event
  }
})

initLogger({
  sentry: Sentry,
  provider: 'app',
  stage: process.env.DEPLOYMENT_STAGE,
  version: process.env.VERSION
})

export { Sentry }
